import React from 'react'

import styles from './template-name.module.scss'
import ReactModal from 'react-modal';

const TemplateNamePopup = (
    {
        IsOpen,
        closeDialog,
        templateTitle,
        editTemplateName,
        isEditingTemplate,
        setTemplateData,
        templateType
    }:
        {
            IsOpen: boolean,
            closeDialog: any,
            templateTitle: any
            editTemplateName: any
            isEditingTemplate: any
            setTemplateData: any
            templateType: string
        }
) => {

    const [title, setTitle] = React.useState<any>(templateTitle)

    React.useEffect(() => {
        setTitle(templateTitle)
    }, [templateTitle && templateTitle.length])
    const invalidTitle = (!title || (title && title.length < 3) || (title.length > 101) || (title.trim() === '') || (title === 'untitled'))

    const editFn = () => {
        setTemplateData((prevState: any) => ({ ...prevState, title: title }))
        editTemplateName()
    }

    return (
        <ReactModal
            id={templateType}
            isOpen={IsOpen}
            className={styles.TemplateNamePopup}
            style={{
                content: {
                    width: "480px",
                },
                overlay: {
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    zIndex: 99999,
                }
            }}
        >
            <div className={styles.TemplateNamePopup__header}>
                {
                    templateType === 'page'
                        ?
                        <h1>Page Title</h1>
                        :
                        <h1>Workflow Name</h1>
                }
            </div>

            <div className={styles.TemplateNamePopup__body}>
                <label>{templateType === 'page' ? 'Title' : 'Name'}</label>
                <input
                    type='text'
                    required
                    placeholder={`Enter ${templateType === 'page' ? 'page title' : 'workflow name'} `}
                    value={title}
                    form-datatype='text'
                    maxLength={100}
                    onChange={e => {
                        e.preventDefault();
                        const messageData = e.target.value
                        if (messageData.trim() === '') {
                            setTitle('')
                        }
                        else {
                            if (messageData.length <= 100) {
                                setTitle(messageData);
                                setTemplateData((prevState: any) => ({ ...prevState, title: messageData }))
                            }
                        }
                    }
                    }
                />
            </div>

            <div className={styles.TemplateNamePopup__footer}>
                <button className={styles.TemplateNamePopup__footer__cancel}
                    onClick={closeDialog}
                >
                    Cancel
                </button>
                <button
                    className={`
                    ${styles.TemplateNamePopup__footer__create}
                     ${(invalidTitle ? `${styles.TemplateNamePopup__footer__disabled}` : '')}`
                    }
                    onClick={editFn}
                    disabled={invalidTitle}
                >
                    {isEditingTemplate ? 'Saving...' : 'Save'}
                </button>
            </div>
        </ReactModal>
    )
}

export default TemplateNamePopup
